export const abbreviateNumber = (number) => {

  if (!number) {
    return '';
  }

  const BILLION = 1_000_000_000;
  const MILLION = 1_000_000;
  const THOUSAND = 1_000;

  if (number >= BILLION) {
    return `${(number / BILLION).toFixed(1).replace(/\.0$/, '')}b`;
  } else if (number >= MILLION) {
    return `${(number / MILLION).toFixed(1).replace(/\.0$/, '')}m`;
  } else if (number >= THOUSAND) {
    return `${(number / THOUSAND).toFixed(1).replace(/\.0$/, '')}k`;
  } else {
    return number.toString();
  }
};

export const convertMonthsToDuration = (
  months,
  formatMode = 'auto', // 'auto' | 'years' | 'months'
  skipOneYear = false
) => {
  const MONTHS_IN_YEAR = 12;

  if (typeof months !== 'number' || isNaN(months) || months <= 0) {
    return '';
  }

  const isOneYear = months === MONTHS_IN_YEAR;
  const isFullYear = months % MONTHS_IN_YEAR === 0 && months >= MONTHS_IN_YEAR * 2;
  const years = months / MONTHS_IN_YEAR;

  switch (formatMode) {
    case 'years':
      return `${years} year${years > 1 ? 's' : ''}`;

    case 'months':
      return `${months} month${months > 1 ? 's' : ''}`;

    case 'auto':
    default:
      if (isFullYear || (isOneYear && !skipOneYear)) {
        return `${years} year${years > 1 ? 's' : ''}`;
      }
      return `${months} month${months > 1 ? 's' : ''}`;
  }
};

export const getMonthsInBusiness = (timeInBusiness) => {
  const inputYear = parseInt(timeInBusiness.slice(0, 4), 10);
  const inputMonth = parseInt(timeInBusiness.slice(4, 6), 10);

  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth() + 1;

  const monthsInBusiness = (currentYear - inputYear) * 12 + (currentMonth - inputMonth) + 1;

  return monthsInBusiness;
};

export const safeToNumber = (value) => {
  const num = Number(value);
  return value === null || value === undefined || value === '' || isNaN(num) ? null : num;
};

export const convertToSnakeCase = (str) => {
  return str.replace(/([A-Z])/g, '_$1').toLowerCase();
};

const getStreet = (inputData) => {
  switch (inputData.buildingType) {
    case 'House':
      return inputData?.houseStreet || '';
    case 'Flat/Apartment':
      return inputData?.flatStreet || '';
    case 'Townhouse/Security Estate':
      return inputData?.townStreet || '';
    case 'Office':
      return inputData?.officeStreet || '';
    default:
      return '';
  }
};

const getUnitNumber = (inputData) => {
  switch (inputData.buildingType) {
    case 'House':
      return inputData?.houseUnitNumber || '';
    case 'Flat/Apartment':
      return inputData?.flatUnitNumber || '';
    case 'Townhouse/Security Estate':
      return inputData?.townUnitNumber || '';
    case 'Office':
      return inputData?.officeUnitNumber || '';
    default:
      return '';
  }
};

const getBuilding = (inputData) => {
  switch (inputData.buildingType) {
    case 'Flat/Apartment':
      return inputData?.flatBuilding || '';
    case 'Townhouse/Security Estate':
      return inputData?.townBuilding || '';
    case 'Office':
      return inputData?.officeBuilding || '';
    default:
      return '';
  }
};

export const formatPayload = (inputData) => {
  return {
    positionInCompany: inputData.positionInCompany,
    title: inputData.title || '',
    idType: inputData.idType,
    passportNumber: inputData.passportNumber || '',
    idNumber: inputData.idNumber || '',
    residentialStatus: inputData.residentialStatus || '',
    whenMovedIn: inputData.whenMovedIn,
    gender: inputData.gender || '',
    dateOfBirth: inputData.dateOfBirth,
    passportCountry: inputData.passportCountry,
    address: {
      street: getStreet(inputData),
      suburb: inputData.suburb || '',
      city: inputData.city || '',
      province: inputData.provinces || '',
      postalCode: inputData.postalCode || '',
      country: inputData.country || '',
      buildingType: inputData.buildingType || '',
      unitNumber: safeToNumber(getUnitNumber(inputData)),
      building: getBuilding(inputData)
    }
  };
};
